import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { useTimeout } from './useTimeout';
/** Returns true once a given amount of time has elapsed since the returned callback has been run */

export function useHasTimeElapsed(time, onTimeElapse) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hasTimeElapsed = _React$useState2[0],
      setHasTimeElapsed = _React$useState2[1];

  var onTimeout = React.useCallback(function () {
    setHasTimeElapsed(true);
    onTimeElapse === null || onTimeElapse === void 0 ? void 0 : onTimeElapse();
  }, []);

  var _useTimeout = useTimeout(onTimeout, time),
      set = _useTimeout.set;

  var begin = React.useCallback(function () {
    return set();
  }, []);
  var reset = React.useCallback(function () {
    return setHasTimeElapsed(false);
  }, []);
  return [hasTimeElapsed, begin, reset];
}
/** Returns true once a given amount of time has elapsed since the component mounted */

export function useHasTimeElapsedSinceMount(time, onTimeElapse) {
  var _useHasTimeElapsed = useHasTimeElapsed(time, onTimeElapse),
      _useHasTimeElapsed2 = _slicedToArray(_useHasTimeElapsed, 2),
      hasTimeElapsed = _useHasTimeElapsed2[0],
      begin = _useHasTimeElapsed2[1];

  React.useEffect(function () {
    begin();
  }, []);
  return hasTimeElapsed;
}